import { Component, Input } from "@angular/core";
import { Timezone } from "src/app/enums/timezone";
import { IClientProfileInfo } from "src/app/models/client/client-info";

@Component({
  selector: "app-client-info-section",
  templateUrl: "./client-info-section.component.html",
  styleUrls: ["./client-info-section.component.scss"],
})
export class ClientInfoSectionComponent {
  @Input() clientProfileInfo: IClientProfileInfo | null = null;
  @Input() primaryClientNumber = "*missing*";
  @Input() isLoading = false;

  get safeClientProfileInfo(): IClientProfileInfo {
    return {
      firstName: this.clientProfileInfo?.firstName ?? "",
      lastName: this.clientProfileInfo?.lastName ?? "",
      billingEmail: this.clientProfileInfo?.billingEmail ?? "",
      companyName: this.clientProfileInfo?.companyName ?? "",
      phoneNumber: this.clientProfileInfo?.phoneNumber ?? "",
      timeZone: this.clientProfileInfo?.timeZone ?? Timezone.Eastern,
    };
  }

  get clientFullName() {
    return `${this.safeClientProfileInfo.firstName} ${this.safeClientProfileInfo.lastName}`;
  }
}
